<template>
  <v-tooltip v-bind="tooltipOptions" v-model="show" :disabled="hasAccess">
    <template #activator="{ on }">
            <span :style="containerStyle" v-on="on">
                <slot></slot>
            </span>
    </template>
    <span v-if="!hasAccess"
          v-html="trans(noPermissionToolTip !== '' && isUserActive ? noPermissionToolTip : 'app.no_access_tooltip')"></span>
  </v-tooltip>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  data: () => ({
    show: false,
  }),
  props: {
    permission: {
      type: [String, Function, Boolean],
      required: false,
      default: () => null,
    },
    tooltip: {
      type: Object,
      required: false,
      default: () => {
      },
    },
    noPermissionToolTip: {
      type: String,
      default: ''
    },
    containerStyle: {
      type: Object,
      required: false,
      default: () => {
      },
    }
  },
  computed: {
    ...mapGetters([
      'hasPermission',
      'isUserActive'
    ]),

    hasAccess() {
      if (typeof this.permission === 'string') {
        return this.hasPermission(this.permission);
      }

      if (typeof this.permission === 'boolean') {
        return this.permission;
      }

      if (typeof this.permission === 'function') {
        return this.permission(this.hasPermission);
      }

      return true;
    },

    tooltipOptions() {
      const defaults = {
        'bottom': true,
        'attach': true,
        'offset-overflow': true,
        'lazy': true,
        ...this.tooltip,
      };

      if (this.hasAccess) {
        return defaults;
      }

      return {
        'close-delay': 2000,
        'max-width': 300,
        ...defaults,
      };
    },
  },
};
</script>

<style scoped>
.v-tooltip__content span {
  text-align: left;
  display: block;
  width: 100%;
}
</style>
